import {forwardRef} from 'react';
import {DetailedProps, join} from '../../utils';
import {Box} from '../box/box';

import styles from './list.module.less';

export const ListItem = forwardRef<HTMLDivElement, DetailedProps<HTMLDivElement>>(
	({className, children, ...props}, ref) =>
		<Box role='listitem' {...props} ref={ref} className={join(styles.listItem, className)}>{children}</Box>
);

export default ListItem;
